import(/* webpackMode: "eager", webpackExports: ["AppDetailView"] */ "/opt/buildhome/repo/src/components/apps/app-detail-view.tsx");
